
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'customizedproductconsultIndex',
		props: {

		},
		data() {
			return {
				moduleName: 'customizedproductconsult',
				windowName: '定制产品咨询',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {

		},
		components: {
			
		}
	}
</script>
